import { GraphQLData } from "interfaces/graphql-data";
import { ITenant } from "interfaces/tenant";
import { AtByModel } from "models/at-by-model";
import { ChangeModel } from "./change";

export class ChangeListModel implements GraphQLData {
  lastEvaluatedKey: string = '';
  changes: Array<ChangeModel> = []

  async hydrate(data: any, tenant: ITenant): Promise<void> {
    console.log(data);
    console.log(data.data);
    
    if (data && data.data && data.data.GetNode) {
      if (data.data.GetNode.ListChanges && data.data.GetNode.ListChanges.echos) {
        const dt = data.data.GetNode.ListChanges;
        this.lastEvaluatedKey = dt.lastEvaluatedKey;
        this.changes = dt.echos.map((o: any) => {
          const nm = o.new ? JSON.parse(o.new) : {};
          const om = o.old ? JSON.parse(o.old) : {};
          const typeName = (nm && nm.type) || (om && om.type);
          let nmAudit = new AtByModel('', '');
          if (o.lastModified && Object.entries(o.lastModified).length > 0) {
            nmAudit = new AtByModel(o.lastModified.at, o.lastModified.by);
          }
          
          const change = new ChangeModel(JSON.stringify(om, null, 2), nmAudit, JSON.stringify(nm, null, 2), nmAudit, typeName);
          return change;
        });
      }
    } else {
      throw new Error('data structured passed in does not contain data, data.data, data.data.GetNode');
    }
  }
}